import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            关于韩漫你想知道的
          </h2>
          <p className="text-foreground-600 text-sm">
            快速解答你的疑惑
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`rounded-xl overflow-hidden transition-all duration-200 ${
                openIndex === index ? 'bg-background-100 shadow-sm' : 'bg-background-100'
              }`}
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  <a href={`#faq-${index}`} className="no-underline text-inherit">
                    {item.question}
                  </a>
                </h4>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-colors ${
                  openIndex === index ? 'bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-sm`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
                id={`faq-${index}`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}